import React from 'react'
import { injectState } from 'freactal'
import styled from 'styled-components'
import { Card, Cell } from 'react-mdl'
import Button from '../../../components/Button'
import TransformedImage from '../../../components/TransformedImage'

const StyledCard = styled(Card)`
  width: 100%;
  z-index: 0;
  & > * {
    display: flex;
    justify-content: space-between;
  }
`
const ChooseImageContainer = styled.div`
  display: inline-flex;
  position: absolute;
  bottom: 0;
  p {
    font-weight: bold;
    padding: 5px;
  }
`
const SlideContainer = styled.div`
  display: inline-block;
  align-self: flex-end;
  width: 300px;
  padding: 0.5em;
`

function CoverImageCard({
  image,
  sectionNumber,
  sectionName,
  onClick,
  state: { unit },
}) {
  return (
    <StyledCard shadow={3}>
      <div>
        <Cell col={8}>
          <div>
            <p>
              <b>{sectionNumber ? 'Section Number: ' : 'Unit Code: '}</b>
              {sectionNumber || unit.code}
            </p>
            <p>
              <b>{sectionName ? 'Section Title: ' : 'Unit Title: '}</b>
              {sectionName || unit.title}
            </p>
          </div>
          <ChooseImageContainer>
            <p>
              {sectionNumber ? 'Section' : 'Presentation'} Cover Image:
            </p>
            <Button primary onClick={onClick}>
              Choose Image
            </Button>
          </ChooseImageContainer>
        </Cell>
        <Cell col={4}>
          <SlideContainer>
            <p><b>Cover Image: </b></p>
            {image
              ? <TransformedImage image={image} />
              : <p>No Image Selected</p>}
          </SlideContainer>
        </Cell>
      </div>
    </StyledCard>
  )
}

export default injectState(CoverImageCard)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/components/CoverImageCard.js